// Page type constants for language loading
export const PAGE_TYPES = {
    SIGN_IN: 'signIn',
    FORGOT_PASSWORD: 'forgotPassword',
    RESET_PASSWORD: 'resetPassword',
} as const

// Type derived from the constants
export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES]

// API endpoints for each page type
export const PAGE_ENDPOINTS = {
    [PAGE_TYPES.SIGN_IN]: 'api/languages/getSignInPageTokens',
    [PAGE_TYPES.FORGOT_PASSWORD]: 'api/languages/getForgotPasswordPageTokens',
    [PAGE_TYPES.RESET_PASSWORD]: 'api/languages/getResetPasswordPageTokens',
} as const
